export default __webpack_public_path__ + "static/media/mc_frontview_open.b93170d9.svg";